import type { TranslateDictionary } from './en.js';

export const Ja: TranslateDictionary = {
  'Start airplay': 'AirPlayを開始',
  'Stop airplay': 'AirPlayを停止',
  Audio: 'オーディオ',
  Captions: 'キャプション',
  'Enable captions': 'キャプションを有効にする',
  'Disable captions': 'キャプションを無効にする',
  'Start casting': 'キャストを開始',
  'Stop casting': 'キャストを停止',
  'Enter fullscreen mode': 'フルスクリーンにする',
  'Exit fullscreen mode': 'フルスクリーンを終了',
  Mute: 'ミュート',
  Unmute: 'ミュート解除',
  'Enter picture in picture mode': 'ピクチャーインピクチャーモードにする',
  'Exit picture in picture mode': 'ピクチャーインピクチャーモードを終了',
  Play: '再生',
  Pause: '一時停止',
  'Playback rate': '再生速度',
  'Playback rate {playbackRate}': '再生速度 {playbackRate}',
  Quality: '画質',
  'Seek backward': '巻き戻し',
  'Seek forward': '早送り',
  Settings: '設定',
  Auto: '自動',
  'audio player': 'オーディオプレーヤー',
  'video player': 'ビデオプレーヤー',
  volume: 'ボリューム',
  seek: '探す',
  'closed captions': 'クローズドキャプション',
  'current playback rate': '現在の再生速度',
  'playback time': '再生時間',
  'media loading': 'メディア読み込み中',
  settings: '設定',
  'audio tracks': 'オーディオトラック',
  quality: '画質',
  play: '再生',
  pause: '一時停止',
  mute: 'ミュート',
  unmute: 'ミュート解除',
  'chapter: {chapterName}': 'チャプター: {chapterName}',
  live: 'ライブ',
  Off: 'オフ',
  'start airplay': 'AirPlayを開始',
  'stop airplay': 'AirPlayを停止',
  'start casting': 'キャストを開始',
  'stop casting': 'キャストを停止',
  'enter fullscreen mode': 'フルスクリーンにする',
  'exit fullscreen mode': 'フルスクリーンを終了',
  'enter picture in picture mode': 'ピクチャーインピクチャーモードにする',
  'exit picture in picture mode': 'ピクチャーインピクチャーモードを終了',
  'seek to live': 'ライブに移動',
  'playing live': 'ライブ再生中',
  'seek back {seekOffset} seconds': '{seekOffset}秒巻き戻し',
  'seek forward {seekOffset} seconds': '{seekOffset}秒早送り',
  'Network Error': 'ネットワークエラー',
  'Decode Error': 'デコードエラー',
  'Source Not Supported': 'ソースはサポートされていません',
  'Encryption Error': '暗号化エラー',
  'A network error caused the media download to fail.':
    'ネットワークエラーによりメディアのダウンロードに失敗しました。',
  'A media error caused playback to be aborted. The media could be corrupt or your browser does not support this format.':
    'メディアエラーにより再生が中止されました。メディアが破損しているか、お使いのブラウザがこの形式をサポートしていません。',
  'An unsupported error occurred. The server or network failed, or your browser does not support this format.':
    'サポートされていないエラーが発生しました。サーバーまたはネットワークが失敗したか、お使いのブラウザがこの形式をサポートしていません。',
  'The media is encrypted and there are no keys to decrypt it.':
    'メディアは暗号化されており、復号化するキーがありません。',
};
